export const CREATE_SPOT_LIST_FAILURE = 'CREATE_SPOT_LIST_FAILURE';

export const createSpotListFailure = (payload: Error) => ({
    type: CREATE_SPOT_LIST_FAILURE,
    payload,
});
